<template>
  <aside
    class="border-r border-gray-20 sticky left-0 z-80 bg-white w-40 flex-shrink-0 relative"
    :class="$style.borderTop"
  >
    <div
      class="flex h-8 items-center px-4 type-scale-n2 relative"
      :class="[month.year && $i !== 0 && $style.borderTop]"
      v-for="(month, $i) in months"
      :key="$i"
    >
      <div class="w-10 font-bold">{{ month.year }}</div>
      <div class="capitalize type-scale-n4">{{ month.month }}</div>
    </div>
  </aside>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'TimetableSidebar',

  computed: {
    months: get('timetable/months')
  }
}
</script>

<style lang="postcss" module>
.borderTop::after {
  content: '';
  height: 1px;
  @apply absolute left-0 top-0 bg-gray-10 w-full;
}
</style>
